import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AdminSidebar.css';

const AdminSidebar = ({ onLogout, sitePath, role = 'admin' }) => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isGestionInfosPage = location.pathname === '/admin/gestion-infos';
  const isVeillePage = location.pathname === '/admin/dashboard-veille';
  const isCleaningPage = location.pathname === '/admin/gestione-pulizie';
  const isBookingsPage = location.pathname === '/admin/gestione-prenotazioni';

  const isCleaningRole = role === 'cleaning';
  const canSeeAdminLinks = role === 'admin';

  return (
    <header className="global-admin-topbar">
      <div className="global-admin-topbar-brand">{isCleaningRole ? 'Pulizie' : 'Admin'}</div>
      <nav className="global-admin-nav">
        {canSeeAdminLinks && (
          <Link to={sitePath} className={!isAdminPage && !isGestionInfosPage && !isVeillePage && !isCleaningPage ? 'active' : ''}>
            Site
          </Link>
        )}

        {canSeeAdminLinks && (
          <Link to="/admin" className={isAdminPage ? 'active' : ''}>
            Encore Dispo
          </Link>
        )}

        {canSeeAdminLinks && (
          <Link to="/admin/gestion-infos" className={isGestionInfosPage ? 'active' : ''}>
            Guides & vidéos
          </Link>
        )}

        {canSeeAdminLinks && (
          <Link to="/admin/dashboard-veille" className={isVeillePage ? 'active' : ''}>
            Dashboard veille
          </Link>
        )}

        {canSeeAdminLinks && (
          <Link to="/admin/gestione-prenotazioni" className={`nav-prenotazioni${isBookingsPage ? ' active' : ''}`}>
            Gestione Prenotazioni
          </Link>
        )}

        <Link to="/admin/gestione-pulizie" className={isCleaningPage ? 'active' : ''}>
          Gestione Pulizie
        </Link>
        <button type="button" onClick={onLogout} className="logout-btn">
          {isCleaningRole ? 'Disconnetti' : 'Se déconnecter'}
        </button>
      </nav>
    </header>
  );
};

export default AdminSidebar;